import { Container } from '@mui/material';

import { styled } from '@mui/material/styles';

export const ContainerStyled = styled(Container)`
  background-color: white;
  padding: 10vh;
`;
